export default "__VITE_ASSET__773b308e__"